import React, { useState, useEffect } from 'react';
import { useRouteMatch, Switch, Route } from 'react-router-dom';
import PageMenu from 'components/PageMenu';
import AppUser, { NoUser } from 'components/Admin/users/AppUser';
import { useGetUsersListQuery } from './GetUsersList.generated';
import { fetchCognitoUsersInAdminGroup } from 'api';

const AppUsers = () => {
  const { path, url } = useRouteMatch();

  const [result] = useGetUsersListQuery();

  const [appUsers, setAppUsers] = useState([]);

  useEffect(() => {
    if (result?.data?.app_users) {
      fetchCognitoUsersInAdminGroup().then(({ Users }) =>
        setAppUsers(
          result.data.app_users?.map((_appUser) => {
            if (
              Users &&
              Users?.some(
                (cognitoUser) => cognitoUser?.Username === _appUser?.id,
              )
            )
              return { ..._appUser, isCognitoAdmin: true };
            else return _appUser;
          }),
        ),
      );
    }
  }, [result]);

  if (!appUsers?.length) {
    return null;
  }

  return (
    <div className="flex flex-col w-full md:flex-row">
      <PageMenu
        base={url}
        items={appUsers?.map((app_user) => ({
          to: `${url}/${app_user?.id}`,
          label: app_user?.id,
          textClass: app_user?.isCognitoAdmin
            ? 'text-red-800 opacity-75'
            : undefined,
          activeTextClass: app_user?.isCognitoAdmin
            ? 'text-red-900'
            : undefined,
          activeIndicatorClass: app_user?.isCognitoAdmin
            ? 'bg-red-600 opacity-25'
            : undefined,
        }))}
      />

      <Switch>
        <Route exact path={`${path}/`}>
          <NoUser />
        </Route>
        {appUsers?.map(({ id, isCognitoAdmin = false }, i) => (
          <Route path={`${path}/${id}`} exact key={i}>
            <AppUser id={id} isCognitoAdmin={isCognitoAdmin} />
          </Route>
        ))}
      </Switch>
    </div>
  );
};

export default AppUsers;
